import { Skeleton } from '@/components/ui/skeleton';
import { PageHeaderSkeleton } from './PageHeaderSkeleton';
import { CardGridSkeleton } from './CardGridSkeleton';
import { PageWrapper } from '@/components/layout';

/**
 * Skeleton for the Bills page.
 * Reserves ~680px total height to prevent CLS.
 *
 * Layout breakdown:
 * - PageHeader with gradient: ~120px
 * - Year selector card: ~70px
 * - Search bar + filters: ~180px
 * - Card grid (6 cards): ~320px
 * - Pagination: ~60px
 */
export function BillsPageSkeleton() {
  return (
    <PageWrapper header={<PageHeaderSkeleton variant="gradient" showDescription={true} />}>
      <div className="py-8 space-y-6">
        {/* Year Selector Card */}
        <div className="bg-card border border-border rounded-lg shadow-sm p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Skeleton className="h-5 w-5 rounded" />
              <Skeleton className="h-5 w-32" />
            </div>
            <Skeleton className="h-9 w-[180px]" />
          </div>
        </div>

        {/* Search and Controls Card */}
        <div className="bg-card border border-border rounded-lg shadow-sm p-6 space-y-4">
          {/* Search Bar */}
          <Skeleton className="h-12 w-full" />

          {/* Filter Controls Row */}
          <div className="flex flex-wrap gap-2">
            <Skeleton className="h-10 w-28" />
            <Skeleton className="h-10 w-28" />
            <Skeleton className="h-10 w-28" />
            <Skeleton className="h-10 w-28" />
            <Skeleton className="h-10 w-24" />
            <Skeleton className="h-10 w-24" />
          </div>

          {/* Results Summary Row */}
          <div className="flex items-center justify-between pt-4 border-t border-border">
            <Skeleton className="h-4 w-48" />
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-12" />
              <Skeleton className="h-8 w-24" />
            </div>
          </div>
        </div>

        {/* Bill Cards Grid */}
        <CardGridSkeleton count={6} />

        {/* Pagination */}
        <div className="bg-card border border-border rounded-lg shadow-sm px-6 py-4">
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-24" />
            <div className="flex items-center gap-2">
              <Skeleton className="h-9 w-20" />
              <Skeleton className="h-9 w-9" />
              <Skeleton className="h-9 w-9" />
              <Skeleton className="h-9 w-9" />
              <Skeleton className="h-9 w-20" />
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}
